import { useMutation } from '@apollo/client';
import { showToast } from 'components/common/CustomToast';
import { SET_DEFAULT_TOKENIZED_PAYMENT_OPTION } from 'graphql/mutations/setDefaultTokenizedPaymentOption';
import { GET_CUSTOMER } from 'graphql/queries/getCustomer';
import {
  Mutation,
  MutationSetDefaultTokenizedPaymentOptionArgs,
  PaymentMethodType,
} from 'types/generatedSchemaTypes';

const useSetDefaultTokenizedPaymentOption = () => {
  const [setDefaultPaymentOption, { loading }] = useMutation<
    Pick<Mutation, 'setDefaultTokenizedPaymentOption'>,
    MutationSetDefaultTokenizedPaymentOptionArgs
  >(SET_DEFAULT_TOKENIZED_PAYMENT_OPTION, {
    refetchQueries: [GET_CUSTOMER],
    awaitRefetchQueries: true,
    onError: () => {
      showToast('error.genericError', 'error');
    },
  });

  const setDefaultTokenizedPaymentOption = (
    paymentOptionId: string,
    paymentOptionType: PaymentMethodType
  ) => {
    return setDefaultPaymentOption({
      variables: {
        input: {
          paymentOptionId,
          paymentOptionType,
        },
      },
    });
  };

  return { setDefaultTokenizedPaymentOption, loading };
};

export default useSetDefaultTokenizedPaymentOption;
